import { HeaderCta } from '@/components/partners/HeaderCta';
import { Hero } from '@/components/partners/Hero';
import { Testimonials } from '@/components/partners/Testimonials';
import { WhoIsThisFor } from '@/components/partners/WhoIsThisFor';
import { WhyUs } from '@/components/partners/WhyUs';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import type { Config } from '@/pageConfig/partners';
interface PartnersProgramPageTemplateProps {
  config: Config;
}

export const PartnersProgramPageTemplate: React.FC<PartnersProgramPageTemplateProps> = ({ config }) => {
  const CHAT_BASE_URL = process.env.AFFILIATE_CHAT_URL || 'https://chat.lemonade.com/affiliates/onboarding?f=1';

  return (
    <Layout
      pt={[115, 150, 190]}
      headerActions={config.layout.headerActions}
      CustomHeaderCTA={
        <HeaderCta
          url={CHAT_BASE_URL}
          desktopText={config.headerCta.desktopText}
          mobileText={config.headerCta.mobileText}
        />
      }
    >
      <SEO {...config.seo} />
      <PageWrapper>
        <Hero url={CHAT_BASE_URL} {...config.hero} />
        <WhoIsThisFor {...config.whoIsThisFor} />
        <WhyUs {...config.whyUs} />
        <Testimonials {...config.testimonials} />
      </PageWrapper>
    </Layout>
  );
};
